import { useEffect, useState } from 'react';
import { WorkspaceAPI } from '../../../../../utils/api';
import { normalizeWorkspaceRole } from '../../../../../utils/workspaceAccess';
import { sortMembers } from '../utils/peopleUtils';

export function useMemberActions({
  workspaceId,
  isPersonal,
  user,
  myRole,
  mayManagePeople,
  setMembers,
  setActionError,
}) {
  const [busyMemberId, setBusyMemberId] = useState(null);
  const [confirmRemoveId, setConfirmRemoveId] = useState(null);

  useEffect(() => {
    setConfirmRemoveId(null);
  }, [workspaceId, isPersonal, user?.sub, user?.email, myRole, mayManagePeople]);

  const handleRoleChange = async (member, nextRole) => {
    if (!member?.userId || busyMemberId) return;
    if (nextRole === normalizeWorkspaceRole(member.role)) return;
    setBusyMemberId(member.userId);
    setActionError('');
    try {
      await WorkspaceAPI.updateMemberRole(workspaceId, member.userId, nextRole);
      setMembers((prev) =>
        sortMembers(
          prev.map((m) => (m.userId === member.userId ? { ...m, role: nextRole } : m))
        )
      );
    } catch (err) {
      setActionError(err?.message || 'Could not change role.');
    } finally {
      setBusyMemberId(null);
    }
  };

  const handleRemove = async (member) => {
    if (!member?.userId || busyMemberId) return;
    setBusyMemberId(member.userId);
    setActionError('');
    try {
      await WorkspaceAPI.removeMember(workspaceId, member.userId);
      setMembers((prev) => prev.filter((x) => x.userId !== member.userId));
      setConfirmRemoveId(null);
    } catch (err) {
      setActionError(err?.message || 'Could not remove this person.');
    } finally {
      setBusyMemberId(null);
    }
  };

  return {
    busyMemberId,
    confirmRemoveId,
    setConfirmRemoveId,
    handleRoleChange,
    handleRemove,
  };
}
